import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import refundFormSubmit from '@hh.ru/analytics-js-events/build/clickme/employer/common/refund_form_submit';

import { fetchBalanceAndBonuses } from 'components/common/BalanceAndBonuses/fetchBalanceAndBonuses';

import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

const REFUND_URL = '/api/v1/account/balance/refund';

interface FetchRefundProps {
    amount: string;
    setIsLoading: (value: boolean) => void;
    handleCloseModal: () => void;
}

export const fetchRefund =
    ({ amount, setIsLoading, handleCloseModal }: FetchRefundProps): AppThunkAction =>
    (dispatch, getState) => {
        setIsLoading(true);

        const user = getState().user.user;
        const userId = user?.id;
        const accountId = user?.currentAccount.id;

        return fetcher
            .post(REFUND_URL, { amount })
            .then(() => {
                refundFormSubmit({
                    amount,
                    userId: userId ?? 0,
                    accountId: accountId ?? 0,
                    paymentSource: 'user',
                });

                handleCloseModal();
                dispatch(addMagritteNotification(MagritteNotificationName.BalanceRefundSuccess));
            })
            .catch(() => {
                dispatch(addMagritteNotification(MagritteNotificationName.BalanceRefundError));
            })
            .then(() => {
                void dispatch(fetchBalanceAndBonuses());
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
